import router from "@/router";
import {Toast} from "mint-ui";
import oRequest from '@/libsV2/request.js';

/**
 * 验证B端权限
 * @param {Function} callBack
 * @returns {Promise<void>}
 */
export const fetchVerifyAuthForB = (callBack = () => ({})) => {
    const id = location.search.split('?')[1]?.split('&')?.map(u => {
        const [key, value] = u.split('=');
        return {key, value}
    })?.find(i => i.key === "salesid")?.value


    // error=0 的情况下 sales_access=1 代表有权限，如果等于0 会有一个sales_msg
    $init(() => {
        oRequest.ajaxData('hvac/sales/access', id ? {salesid: id} : {}).then(({data}) => {
        // oRequest.ajaxData('hvac/sales/access', {salesid: '6219dbda-ec7c-eb11-b0bb-0017fa026433'}).then(({data}) => {
            const {error, data: {sales_access, sales_msg}, msg} = data;
            if (error === 0 && sales_access === 1) {
                callBack()
            } else if (error === 0) {
                router.push('/ant/error');
                Toast(sales_msg)
            } else {
                Toast(msg);
                throw new Error(msg);
            }
        });
    });
}